<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import DATABASE from "@/assets/pic/DATABASE.png";
</script>

<template>
  <div class="bg-gradient-to-b from-white to-blue-50 min-h-screen">
    <index-navbar/>

    <!-- 主体部分 -->
    <section class="relative pt-24 pb-16 flex items-center">
      <div class="container mx-auto flex flex-wrap items-center px-6 md:px-12">
        <!-- 左侧文本 -->
        <div class="w-full lg:w-6/12 xl:w-5/12 mb-10 lg:mb-0 mt-4">
          <h2 class="font-bold text-4xl text-blueGray-700 mb-6 leading-snug">
            MigraineNexus
          </h2>

          <div class="bg-white/80 p-6">
            <p class="text-blueGray-600 text-base leading-relaxed text-justify">
              <span class="font-semibold">MigraineNexus</span> is a comprehensive database that integrates migraine-related multi-species genomic data to facilitate the exploration of migraine mechanisms and the identification of potential molecular targets. By aggregating gene expression data from human, mouse, and rat studies, it supports the investigation of gene-level changes across species and experimental conditions. The platform provides an intuitive gene expression analysis tool, allowing users to search for genes of interest, retrieve detailed annotations, and access linked resources such as GeneCards and NCBI for further reference.
              <br><br>
              A distinguishing feature of MigraineNexus is its incorporation of traditional Chinese medicine (TCM)–related gene annotations, leveraging the BATMAN-TCM database to connect herbal compounds with candidate migraine-associated gene targets. In parallel, MigraineNexus builds a literature-derived biomedical knowledge graph that captures and visualizes complex relationships among genes, drugs, symptoms, and other relevant entities in migraine research. This graph supports entity-based searches and offers direct access to underlying literature for contextual validation.
              <br><br>
              Our goal is to provide a user-friendly interface and integrative platform for migraine-related genomic analysis, with expanded insights from both Western and traditional medicine. Through harmonized data integration, interactive modules, and literature-backed knowledge mapping, MigraineNexus serves as a centralized resource to support both scientific research and clinical exploration in the field of migraine.
            </p>
          </div>
        </div>

        <!-- 右侧图片 -->
        <div class="w-full lg:w-6/12 xl:w-7/12 flex justify-center">
          <img
            :src="DATABASE"
            alt="MigraineNexus Database"
            class="rounded-2xl shadow-2xl max-w-md lg:max-w-lg xl:max-w-2xl transition-transform duration-500 hover:scale-105"
          />
        </div>
      </div>
    </section>

    <footer-component/>
  </div>
</template>
